export default class ToySdk {
  constructor({
    gid, type, locale, country, platform,
  }) {
    this.gid = gid
    this.type = type
    this.locale = locale
    this.country = country
    this.platform = platform
  }
}
